// FILE: src/pages/StudentResourceListPage.jsx
// Retired (frontend-audit B-12): the old chapter/homelink list was
// unreachable and read the wrong store slice. Lessons are listed on the
// dashboard, so the old URLs land there. The default export stays so the
// routes in App.js keep compiling until they are removed.
import { Navigate } from "react-router-dom";

export default function StudentResourceListPage() {
  return <Navigate to="/student" replace />;
}
